import { TableHead } from '@mui/material';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';

import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: '24px',
  [`&.${tableCellClasses.head}`]: {
    fontSize: theme.typography.fontSize,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: theme.typography.fontSize,
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  borderBottom: '2px',
  borderBottomStyle: 'solid',
  borderBottomColor: theme.palette.borders.dark,
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  borderBottom: '8px',
  borderBottomStyle: 'solid',
  backgroundColor: theme.palette.action.selected,
  borderBottomColor: theme.palette.background.default,
}));
